import { useAtomCallback } from 'jotai/utils';
import { useCallback, useState } from 'react';

import { logger } from '../../datadog/logger';
import { toast } from '../../toasts';
import { roomAtom, roomToDiagnosticInfo, videoSDKAdapterAtom } from '../../video-sdk';

export function useRemoveClientCallback() {
  const getRoom = useAtomCallback(useCallback((get) => get(roomAtom), []));
  const getVideoSDKAdapter = useAtomCallback(useCallback((get) => get(videoSDKAdapterAtom), []));
  const [loading, setLoading] = useState(false);

  const callback = useCallback(
    async (participantSid: string) => {
      const room = getRoom();
      if (!room) return;
      setLoading(true);
      try {
        await getVideoSDKAdapter().removeParticipant(participantSid);
      } catch (error) {
        toast.error('Something went wrong when trying to remove the client from the session');
        logger.error('Unable to remove client from session', roomToDiagnosticInfo(room), error as Error);
      } finally {
        setLoading(false);
      }
    },
    [], // eslint-disable-line react-hooks/exhaustive-deps
  );

  return { callback, loading };
}
